module.exports = __webpack_public_path__ + "static/media/threeUp-general-liability.c36e5372.png";